import { IonContent } from '@ionic/react';
import { motion } from 'motion/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { useRoomData } from '../../hooks/useRoomBackgroundImage';

import { ChatMessage } from './components';
import {
  ScreenExperienceGalleryStyles,
  ChatWrapperStyles,
  ChatContainerStyles,
  AnimatedBottomButtonContainer,
} from './ExperienceGallery.styles';

export const ScreenExperienceGallery: React.FC = () => {
  const { wizard } = useOnboarding();
  const roomData = useRoomData();

  // Animation states
  const [showFirstMessage, setShowFirstMessage] = React.useState(false);
  const [showSecondMessage, setShowSecondMessage] = React.useState(false);
  const [showFooter, setShowFooter] = React.useState(false);

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'RoomPreview',
      });
    }
  }, []);

  // Show first message
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowFirstMessage(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Show second message after first
  React.useEffect(() => {
    if (showFirstMessage) {
      const timer = setTimeout(() => {
        setShowSecondMessage(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [showFirstMessage]);

  // Show footer after second message
  React.useEffect(() => {
    if (showSecondMessage) {
      const timer = setTimeout(() => {
        setShowFooter(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [showSecondMessage]);

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <ScreenExperienceGalleryStyles
      bgImage={<img src={roomData.image} alt="Chat Vibe" />}
      bgImageMask={false}
      background="dark-solid"
    >
      <IonContent>
        <motion.div layout>
          <ChatWrapperStyles>
            <ChatContainerStyles>
              <ChatMessage
                content={roomData.firstMessage}
                variant="received"
                show={showFirstMessage}
                delay={0}
              />

              <ChatMessage
                content={roomData.secondMessage}
                variant="received"
                show={showSecondMessage}
                delay={0.2}
                color="neutral-white"
              />
            </ChatContainerStyles>
          </ChatWrapperStyles>
        </motion.div>
      </IonContent>

      <AnimatedBottomButtonContainer show={showFooter}>
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonText={'Unlock Experience'}
          variant={'with-content'}
          contentText={'Ready to enter the room and continue with her?'}
        />
      </AnimatedBottomButtonContainer>
    </ScreenExperienceGalleryStyles>
  );
};
